<template>
    <v-app class="overflow-hidden" id="layout">
        <v-defaults-provider :defaults="defaultProvider">
            <!-- start v-navigation-drawer -->
            <v-navigation-drawer
                v-model="drawer"
                temporary
                location="right"
                flat
            >
                <!-- :style=" drawer && $vuetify.display.smAndDown ? 'bottom: 64px;' : 'bottom: 0px' " -->
                <v-list>
                    <v-list-item>
                        <v-img
                            :src="asset('images/logo/logo-krisan-new.svg')"
                            height="70"
                        />
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list density="compact" nav>
                    <template v-for="m in menu">
                        <v-list-item
                            :key="m.title"
                            v-if="m.type == 'btn' && $can('read', m.access)"
                            :title="m.title"
                            :to="{ name: m.name }"
                        >
                            <template #prepend>
                                <v-icon :class="m.icon"></v-icon>
                            </template>
                        </v-list-item>
                        <v-list-group
                            v-if="
                                m.type == 'dropdown' && $can('read', m.access)
                            "
                            :value="m.title"
                            :key="m.title"
                        >
                            <template v-slot:activator="{ props }">
                                <v-list-item v-bind="props" :title="m.title">
                                    <template #prepend>
                                        <v-icon :class="m.icon"></v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                            <template v-for="l in m.list">
                                <v-list-item
                                    v-if="$can('read', l.access)"
                                    :title="l.title"
                                    :to="{ name: l.name }"
                                    link
                                    :key="l.name"
                                >
                                    <template #prepend>
                                        <v-icon :class="l.icon"></v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list-group>
                    </template>
                    <div style="height: 65px"></div>
                </v-list>
            </v-navigation-drawer>
            <!-- end v-navigation-drawer -->

            <!-- app bar top -->
            <!-- banner offline -->
            <v-app-bar v-if="offline" style="z-index: 1006">
                <v-banner :sticky="true" lines="two" height="fit-content">
                    <template v-slot:prepend>
                        <v-avatar color="red">
                            <v-icon class="icon-[tabler--wifi-off]"></v-icon>
                        </v-avatar>
                    </template>
                    <template v-slot:text>
                        Oops, anda offline. periksa koneksi internet anda.
                    </template>
                </v-banner>
            </v-app-bar>
            <v-overlay v-model="offline" persistent z-index="1005"></v-overlay>
            <!-- scroll app bar -->
            <v-app-bar
                aspect-ratio="1"
                app
                flat
                class="drop-shadow-xl user-layout"
                :class="{
                    '!border-b-[1px] !border-[#2e3c34]':
                        $vuetify.theme.current.dark,
                }"
                :height="$vuetify.display.mdAndUp ? 100 : 80"
                style="z-index: 100"
                scroll-behavior="hide inverted"
                scroll-threshold="280"
            >
                <navigation-bar
                    :countMenu="countMenu"
                    :menu="menu"
                    @emitDrawer="handleDrawer"
                    :drawer="drawer"
                ></navigation-bar>
            </v-app-bar>

            <!-- banner install app -->
            <!-- <v-expand-transition>
                <v-app-bar
                    v-if="deferredPrompt != null && banner"
                    :order="$vuetify.display.mdAndUp ? 0 : 1"
                    :location="$vuetify.display.mdAndUp ? 'top' : 'bottom'"
                    :height="$vuetify.display.mdAndUp ? '60' : '90'"
                    class="flex align-center justify-center"
                >
                    <v-banner lines="two" border="none" class="px-3">
                        <div
                            class="flex justify-between align-center gap-3 w-full"
                        >
                            <div class="flex gap-5 align-center">
                                <div>
                                    <v-avatar color="primary">
                                        <v-icon
                                            class="icon-[tabler--download]"
                                        ></v-icon>
                                    </v-avatar>
                                </div>
                                <div>
                                    Install aplikasi RS Pendidikan di perangkat
                                    mu.
                                </div>
                            </div>
                            <div class="flex align-center gap-1">
                                <v-btn
                                    @click="installApp"
                                    color="primary"
                                    variant="elevated"
                                    rounded="lg"
                                    class="w-fit"
                                    size="small"
                                >
                                    install
                                </v-btn>
                                <v-btn
                                    @click="installLater"
                                    color="primary"
                                    variant="text"
                                    rounded="lg"
                                    class="w-fit"
                                    size="small"
                                    icon
                                >
                                    <v-icon
                                        class="icon-[ic--round-close]"
                                    ></v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-banner>
                </v-app-bar>
            </v-expand-transition> -->

            <!-- social media bar -->
            <!-- #1b7955 -->
            <v-app-bar height="40" color="#4298af" flat absolute>
                <div class="boxed-navbar px-5">
                    <v-btn
                        :icon="!$vuetify.display.mdAndUp"
                        rounded="lg"
                        variant="text"
                        color="white"
                        class="text-lowercase"
                        href="mailto:rsudcibinong.instalasidiklat@gmail.com"
                    >
                        <v-icon
                            class="icon-[tabler--mail]"
                            :start="$vuetify.display.mdAndUp"
                            size="20"
                        />

                        <div v-if="$vuetify.display.mdAndUp">
                            rsudcibinong.instalasidiklat@gmail.com
                        </div>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        size="small"
                        color="white"
                        icon
                        href="https://www.instagram.com/diklatdanriset_rsudcibinong"
                        target="_blank"
                    >
                        <v-icon
                            class="icon-[tabler--brand-instagram]"
                            size="large"
                        />
                    </v-btn>
                    <v-btn
                        disabled
                        size="small"
                        color="white"
                        icon
                        href=""
                        target="_blank"
                    >
                        <v-icon
                            class="icon-[tabler--brand-facebook]"
                            size="large"
                        />
                    </v-btn>
                    <v-btn
                        disabled
                        size="small"
                        color="white"
                        icon
                        href=""
                        target="_blank"
                    >
                        <v-icon
                            class="icon-[tabler--brand-twitter]"
                            size="large"
                        />
                    </v-btn>
                    <v-btn
                        disabled
                        size="small"
                        color="white"
                        icon
                        href=""
                        target="_blank"
                    >
                        <v-icon
                            class="icon-[tabler--brand-youtube]"
                            size="large"
                        />
                    </v-btn>
                    <v-btn disabled color="white" icon href="" target="_blank">
                        <v-icon
                            class="icon-[tabler--brand-tiktok]"
                            size="small"
                        />
                    </v-btn>
                </div>
            </v-app-bar>
            <!-- color="#52bc94" -->
            <v-app-bar
                aspect-ratio="1"
                absolute
                flat
                class="drop-shadow-xl user-layout"
                :height="$vuetify.display.mdAndUp ? 100 : 80"
            >
                <navigation-bar
                    :countMenu="countMenu"
                    :menu="menu"
                    @emitDrawer="handleDrawer"
                    :drawer="drawer"
                ></navigation-bar>
            </v-app-bar>

            <v-main id="main" class="layout-page-content">
                <router-view v-slot="{ Component }">
                    <!-- <v-slide-y-transition mode="out-in"> -->
                    <!-- <component :is="Component" /> -->
                    <!-- </v-slide-y-transition> -->

                    <transition name="page">
                        <component :is="Component" />
                    </transition>
                </router-view>

                <!-- <div
                    :style="
                        $vuetify.display.lgAndUp
                            ? 'height: 450px'
                            : 'height: 1040px'
                    "
                ></div> -->
                <!-- footer -->
                <!-- v-if="$vuetify.display.lgAndUp" -->
                <!-- workshop timer -->
                <v-fab
                    v-if="
                        route.name == 'workshopPreTest' ||
                        route.name == 'workshopPostTest'
                    "
                    color="white"
                    app
                    appear
                    style="bottom: 30px; right: 20px"
                >
                    {{ dateTime.duration(authStore.timer).format("HH:mm:ss") }}
                </v-fab>

                <v-fab
                    app
                    style="bottom: 30px; left: 20px"
                    location="bottom start"
                    size="large"
                    icon
                    rounded="full"
                    href="https://wa.me/62811128347"
                >
                    <v-icon
                        class="icon-[tabler--brand-whatsapp]"
                        size="40"
                    ></v-icon>
                </v-fab>

                <FooterGuest />
            </v-main>
        </v-defaults-provider>
    </v-app>
</template>

<script setup>
// import { VFab } from "vuetify/labs/VFab";
import { asset, replaceAvaByDefault, dateTime } from "@/mixins";
import menu from "@/menu";
import NavigationBar from "./NavigationBar.vue";
import BottomAppBar from "./component/BottomAppBar.vue";

import FooterGuest from "./FooterGuest.vue";
import {
    ref,
    onMounted,
    computed,
    provide,
    reactive,
    onBeforeUnmount,
} from "vue";
import { useTheme, useDisplay } from "vuetify";
import ability from "@/plugins/casl/ability";

import { useAuthStore } from "@/store/auth.js";
const authStore = useAuthStore();

import { useRoute } from "vue-router";
const route = useRoute();

const theme = useTheme();
const { xs } = useDisplay();
const isDark = computed(() => {
    let current = theme.current.value;
    return current.dark;
});

const countMenu = computed(() => {
    return menu.filter((f) => {
        return ability.can("read", f.access);
    }).length;
});
const isDisplay = computed(() => {
    return xs;
});

provide("$isDark", isDark);

const defaultProvider = reactive({
    VCard: {
        border: isDark,
    },
    VToolbar: {
        border: isDark,
    },
    VDialogFull: {
        fullscreen: xs,
        persistent: true,
        scrollable: true,
    },
});

const drawer = ref(false);
const offsetTop = ref(0);

const handleDrawer = () => {
    drawer.value = !drawer.value;
};

const onScroll = () => {
    offsetTop.value = window.top.scrollY;
};

const offline = ref(false);
function handleConnectionChange() {
    offline.value = !navigator.onLine;
}

const banner = ref(false);
provide("$banner", banner);
let deferredPrompt = ref(window._deferredPrompt);
provide("$deferredPrompt", deferredPrompt);

async function installApp() {
    banner.value = false;
    if (deferredPrompt.value) {
        deferredPrompt.value.prompt();
        const { outcome } = await deferredPrompt.value.userChoice;
        if (outcome === "accepted") {
            deferredPrompt.value = null;
        } else {
            deferredPrompt.value = window._deferredPrompt;
        }
    }
}

function installLater() {
    localStorage.setItem("installLater", JSON.stringify(true));
    banner.value = false;
}

onMounted(() => {
    window.addEventListener("scroll", onScroll);
    window.addEventListener("offline", handleConnectionChange);
    window.addEventListener("online", handleConnectionChange);
    let install = JSON.parse(localStorage.getItem("installLater"));
    if (
        !install &&
        !authStore.isIos &&
        !window.matchMedia("(display-mode: standalone)").matches
    ) {
        setTimeout(() => {
            banner.value = true;
        }, 10000);
    }
});

onBeforeUnmount(() => {
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("offline", handleConnectionChange);
    window.removeEventListener("online", handleConnectionChange);
});

// app.config.globalProperties.$offsetTop = offsetTop.value;
</script>

<style scoped>
/* .layout-page-content {
    inline-size: 100%;
    margin-inline: auto;
    max-inline-size: 1400px;
    width: 100vw;
} */

.layout-page-content {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
}

.accelerate {
    transform: translateZ(0) !important;
    transform: translate3d(0, 0, 0) !important;
    will-change: transform, opacity;
}
</style>
